import {Store, Module, ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import Tpl from '../entities/tpls/tpl'
import TplForSelect from '../entities/tpls/tplForSelect';
interface TplState extends ListState<Tpl>{
    tplsForSelect: TplForSelect[],
    typeForSelect : [],
}
class TplModule extends ListModule<TplState,any,Tpl>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<Tpl>(),
        loading:false,
        tplsForSelect : new Array<TplForSelect>(),
        typeForSelect:[],
    }
    actions={
        async getAll(context:ActionContext<TplState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/tpl/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Tpl>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async get(context:ActionContext<TplState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/tpl/GetDetail?Id='+payload.data.id);
            return reponse.data.result;
        },
        async getListForSelect(context: ActionContext<TplState, any>,payload:any) {
            let reponse = await Ajax.get('/api/services/app/tpl/GetTpls',{ params : payload.data });
            context.state.tplsForSelect = reponse.data.result as TplForSelect[];
        },
        async getTypesForSelect(context: ActionContext<TplState, any>,payload:any) {
            let reponse = await Ajax.get('/api/services/app/tpl/types');
            context.state.typeForSelect = reponse.data.result
           return reponse.data.result ;
        },
        async searchTplForSelect(context:ActionContext<TplState,any>,payload:any){
            const {data:{result} }  =await Ajax.get('/api/services/app/Tpl/SearchTplForSelect/'+payload.data);
            return result.items  as TplForSelect[];
        },
        async create(context: ActionContext<TplState, any>, payload: any) {
            await Ajax.post('/api/services/app/tpl/Create', payload.data);
        },
        async update(context: ActionContext<TplState, any>, payload: any) {
            await Ajax.put('/api/services/app/tpl/Update', payload.data);
        },
        async switchState(context: ActionContext<TplState, any>, payload: any) {
            await Ajax.put('/api/services/app/tpl/SwitchState?id=' + payload.data.id , {});
        }
    };
    mutations={
        setCurrentPage(state:TplState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:TplState,pagesize:number){
            state.pageSize=pagesize;
        },
    }
}
const tplModule=new TplModule();
export default tplModule;